import { render, staticRenderFns } from "./ChatbotFab.vue?vue&type=template&id=57433f31&scoped=true"
import script from "./ChatbotFab.vue?vue&type=script&lang=ts"
export * from "./ChatbotFab.vue?vue&type=script&lang=ts"
import style0 from "./ChatbotFab.vue?vue&type=style&index=0&id=57433f31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57433f31",
  null
  
)

export default component.exports